import request from '@/utils/request'

export function updateChessIdCfg(data) {
  return request({
    url: 'api/v1/chess-id/update',
    method: 'post',
    data: data
  })
}

export function getChessIdCfgList(data) {
  return request({
    url: 'api/v1/chess-id/getList',
    method: 'post',
    data: data
  })
}

export function getChessIdAllCfgList(data) {
  return request({
    url: 'api/v1/chess-id/getAllList',
    method: 'post',
    data: data
  })
}

export function delChessIdCfg(data) {
  return request({
    url: 'api/v1/chess-id/del',
    method: 'delete',
    data: data
  })
}

